import { action } from 'satcheljs';

export const setSafeLinksSettingAction = action(
    'setSafeLinksSettingAction',
    (isToggledOn: boolean) => ({
        isSafeLinksEnabled: isToggledOn,
    })
);
